import { isEnv } from 'app/ui_v2/helpers/environments';

import { RAYGUN_PROD, RAYGUN_UAT } from '../config';

export const getErrorMessage = (error: Error): string => {
  if (!error.stack) {
    return error.message || error.toString();
  }
  return error.stack;
};

export const isRaygunEnabled = (): string | false => {
  // only for UAT and Production
  if (isEnv('uat')) {
    return RAYGUN_UAT;
  }

  if (isEnv('production')) {
    return RAYGUN_PROD;
  }

  return false;
};
